__turbopack_context__.v({
  "about-image": "jL68uW_about-image",
  "author": "jL68uW_author",
  "avatar": "jL68uW_avatar",
  "car": "jL68uW_car",
  "description": "jL68uW_description",
  "logos": "jL68uW_logos",
  "simulation-card-wrapper": "jL68uW_simulation-card-wrapper",
  "testimonial": "jL68uW_testimonial",
  "testimonial-caption": "jL68uW_testimonial-caption",
  "testimonial-slide": "jL68uW_testimonial-slide",
});
